import React from 'react';
import { Screen } from '../types';

const ApplicationTypeScreen = ({ navigateTo, setMembers }) => {
  const handleIndividual = () => {
    setMembers([]);
    navigateTo(Screen.PermitValidity);
  };

  const handleGroup = () => {
    navigateTo(Screen.GroupApplication);
  };

  return (
    <div className="ilp-screen gray-bg">
      <div className="ilp-header white-bg">
        <button className="ilp-back-btn" onClick={() => navigateTo(Screen.PurposeOfVisit)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2>Application Type</h2>
        <div className="ilp-header-spacer"></div>
      </div>

      <div className="ilp-type-content">
        <div className="ilp-type-intro">
          <span className="ilp-step-badge">Step 4 of 5</span>
          <h1>Traveling alone or with others?</h1>
          <p>Select your application mode.</p>
        </div>

        <div className="ilp-type-options">
          <button className="ilp-type-option" onClick={handleIndividual}>
            <div className="ilp-type-icon blue">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div className="ilp-type-text">
              <h4>Individual</h4>
              <p>Just for myself. Fast-track processing for solo travelers.</p>
            </div>
          </button>

          <button className="ilp-type-option" onClick={handleGroup}>
            <div className="ilp-type-icon orange">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div className="ilp-type-text">
              <h4>Group Application</h4>
              <p>Family or friends (Up to 6 members). Manage all permits in one go.</p>
            </div>
          </button>
        </div>

        <div className="ilp-type-note">
          <p>Note: All members in a group must enter and exit together.</p>
        </div>
      </div>
    </div>
  );
};

export default ApplicationTypeScreen;

